import Qs from 'qs'
import FetchFactory from '../factory'

interface IJob {
  params: {
    job_slug: string
  }
}

interface IJobSaved {
  body: {
    job_id: string
  }
}

interface IJobApply {
  body: {
    resume_id: string
    answers: Array
  }
  params: {
    job_slug: string
  }
}

// interface IJobById {
//     params: {
//         id: string
//     }
// }

// interface IJobChart {
//     params: {
//         id: string
//     }
//     query: {
//         month: number
//     }
// }

// interface IQuestions {
//     params: {
//         job_id: string
//     }
//     body: { questions: Array<Object> }
// }

// interface IJobStatus {
//     body: {
//         status: string
//     }
//     params: {
//         job_id: string
//     }
// }

// interface IJobBulkStatus {
//     body: {
//         job_ids: string
//         status: string
//     }
// }

interface IJobs {
  query: {
    filter: {
      search: string
      location_id: number
      category_id: string
      job_type_id: string
      jlpt_level: string
      is_jft_required: string
      minimum_salary: string
      maximum_salary: string
      date_posted: string
    }
    page: number
    limit: number
  }
}

class JobModule extends FetchFactory<any> {
    async getJobs(payload: IJobs) {
        const { query } = payload

        return await useAsyncData(() => {
            return super.call(`/api/job-seeker/jobs?${Qs.stringify(query)}`, {
                method: 'GET',
      })
        })
    }

    async getJob(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(`/api/job-seeker/jobs/${params.job_slug}`, {
                method: 'GET',
      })
        })
    }

    getSingleJobSEO(payload: IJob) {
        const { params } = payload
        return super.call(`/api/job-seeker/jobs/${params.job_slug}/meta`, {
            method: 'GET',
    })
  }

    async getCompanyOverview(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/company`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async getSimilarJobs(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/similar`,
                {
                    method: 'GET',
                },
      )
        })
    }

    async savedJob(payload: IJobSaved) {
        const { body } = payload

        return await useAsyncData(() => {
            return super.call('/api/job-seeker/jobs/bookmark', {
                method: 'POST',
                body
            })
        })
    }

    async getQuestions(payload: IJob) {
        const { params } = payload

        return await useAsyncData(() => {
            return super.call(
                `/api/job-seeker/jobs/${params.job_slug}/questions`,
                {
                    method: 'get',
                },
      )
        })
    }

    async applyJob(payload: IJobApply) {
        const { body, params } = payload

        return await useAsyncData(() => {
            return super.call(`/api/job-seeker/jobs/${params.job_slug}/apply`, {
                method: 'POST',
                body
            })
        })
    }
}

export default JobModule
